import { Component, OnInit } from '@angular/core';
import { JeevesOrderCardListComponent } from 'gung-standard-jeeves';
import { AuthService, LocationConfigService, Order, PriceConfigService } from 'gung-standard';
import { CultOrderActionConfigService } from '../../services/cult-order-action-config.service';
import { first } from 'rxjs';

@Component({
    selector: 'cult-cult-order-card-list',
    templateUrl: './cult-order-card-list.component.html',
    styleUrls: ['./cult-order-card-list.component.scss'],
    standalone: false
})
export class CultOrderCardListComponent extends JeevesOrderCardListComponent implements OnInit {
  isReturNoPrice = false;

  constructor(
    protected authService: AuthService,
    public configService: CultOrderActionConfigService,
    protected locationConfigService: LocationConfigService,
    public priceConfigService: PriceConfigService
  ) {
    super(configService, locationConfigService, priceConfigService);
  }

  ngOnInit(): void {
    this.authService
      .getCurrentUser()
      .pipe(first())
      .subscribe(user => {
        this.isReturNoPrice = user.roles.includes('RETUR_NOPRICE');
      });
  }

  goToPage(url) {
    window
      .open('https://www.dhl.com/se-en/home/tracking/tracking-freight.html?submit=1&tracking-id=' + url, '_blank')
      .focus();
  }
}
